import React from 'react';
import { injectIntl } from 'react-intl';
import { Alert } from 'react-bootstrap';

import RichEditorContent from 'components/RichEditorContent';

import AbstractTimelineEvent from './AbstractTimelineEvent';

class TimelineReopened extends AbstractTimelineEvent {
  render() {
    const {
      intl: { messages },
      event,
    } = this.props;

    return (
      <div className="card-block">
        <RichEditorContent content={event.getText()} />

        {event && event.getParams() && event.getParams().length ? (
          <RichEditorContent
            content={'<div class="m-l-10 m-t-10 b-l padding-10">' + this.getParam('reopenReason', '') + '</div>'}
          />
        ) : (
          <Alert>{messages.no_reason_specified}</Alert>
        )}
      </div>
    );
  }
}

export default injectIntl(TimelineReopened);
